// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2Fafz","label":"Completed_label__zB-BL"};